import { render } from "./SospensioniRiattivazioni.vue?vue&type=template&id=311a8194"
import script from "./SospensioniRiattivazioni.vue?vue&type=script&lang=js"
export * from "./SospensioniRiattivazioni.vue?vue&type=script&lang=js"

import "./SospensioniRiattivazioni.vue?vue&type=style&index=0&id=311a8194&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__